const trimTrailingSlash = (value) => value.replace(/\/$/, '')

const resolveBackendBase = () => {
  const explicitBase = import.meta.env.VITE_BACKEND_URL
  if (explicitBase) {
    return trimTrailingSlash(explicitBase)
  }

  return ''
}

const backendBase = resolveBackendBase()

export const buildBackendUrl = (path) => {
  if (!path.startsWith('/')) {
    throw new Error(`Expected absolute path, received: ${path}`)
  }

  if (!backendBase) return path
  return `${backendBase}${path}`
}

export const getBackendBase = () => backendBase
